import { useAppSelector } from 'hooks/redux.hooks';
import _ from 'lodash';
//components
import { useTheme, Box, Divider, Typography, ListItem, Button } from '@mui/material';
import FormIcon from './FormIcon';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { EditButton } from 'theme/elements/Buttons';
import { FormInputsTypes } from 'constants/settings.constants';
import { formItemType } from './FormItems';

export interface radioProps {
	handleChange: any;
	options: { value: any; label: string }[];
	value: any;
	label: string;
}

export default function FormItem(props: { content: formItemType; handleEdit: any; editButtonLabel?: string }) {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const { content, handleEdit } = props;
	return (
		<>
			<ListItem sx={{ padding: 0, height: '60px' }}>
				<Box
					sx={{
						width: '100%',
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
							}}
						>
							<FormIcon icon={content.icon} />
							<Typography
								sx={{
									color: theme.palette.root.basicDeeoGreen,
									fontSize: '18px',
									direction: content.type === FormInputsTypes.PHONE ? 'ltr /*@noflip*/' : 'inherit',
								}}
							>
								{content.text}
							</Typography>
						</Box>
						{!content.disable && (
							<EditButton handleClick={() => handleEdit(content)} label={props.editButtonLabel} />
						)}
					</Box>
				</Box>
			</ListItem>
			<Divider sx={{ width: '100%', borderColor: theme.palette.root.divider }} />
		</>
	);
}
